import { render, staticRenderFns } from "./ClaimProvisionForm.vue?vue&type=template&id=488861c4"
import script from "./ClaimProvisionForm.vue?vue&type=script&lang=ts"
export * from "./ClaimProvisionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports